import { render, staticRenderFns } from "./RecommendationCrossSell.vue?vue&type=template&id=cf7f105e&"
import script from "./RecommendationCrossSell.vue?vue&type=script&lang=js&"
export * from "./RecommendationCrossSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports